import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzButtonModule, NzGridModule, NzIconModule, NzLayoutModule, NzMenuModule } from 'ng-zorro-antd';
import { NgZorroAntdModule } from './ng-zorro-antd.module';
import { SearchbarComponent } from './layout/searchbar/searchbar.component';
import { NavbarComponent } from './layout/navbar/navbar.component';
import { MenuComponent } from './layout/menu/menu.component';
import { SidebarComponent } from './layout/sidebar/sidebar.component'
import { AboutSidebarComponent } from './layout/about-sidebar/about-sidebar.component'
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { SafeHtml } from './helpers/safe-html.pipe';
import {TimeAgoPipe} from 'time-ago-pipe';
import { from } from 'rxjs';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { NgxOrgChartModule } from 'ngx-org-chart';
import { QuillModule } from 'ngx-quill';
@NgModule({
  declarations: [
    SearchbarComponent,
    NavbarComponent,
    MenuComponent,
    SidebarComponent,
    AboutSidebarComponent,
    SafeHtml,
    TimeAgoPipe
  ],
  imports: [
    CommonModule,
    NgZorroAntdModule,
    RouterModule,
    InfiniteScrollModule,
    FormsModule,
    NzIconModule,
    NgxOrgChartModule,
    QuillModule.forRoot({
      modules: {
        toolbar: [
          ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
          ['blockquote'],           // custom button values
          [{ 'list': 'ordered'}, { 'list': 'bullet' }],
          [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent

          [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
          [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

          [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
          [{ 'font': [] }],
          [{ 'align': [] }],

          ['clean'],                                      // remove formatting button
          ['link', 'image', 'video'],
        ],
      },
      placeholder: 'Nhập nội dung...',
      theme: 'snow',
    }),
  ],
  exports: [
    NzLayoutModule,
    NzMenuModule,
    NzButtonModule,
    NzIconModule,
    NzGridModule,
    NgZorroAntdModule,
    SearchbarComponent,
    NavbarComponent,
    MenuComponent,
    SidebarComponent,
    AboutSidebarComponent,
    InfiniteScrollModule,
    SafeHtml,
    TimeAgoPipe,
    NgxOrgChartModule,
    QuillModule
  ]
})
export class SharedModule { }
